var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.local_props.filter_list),function(field){return _c('div',[_c('FilterGeneric',{ref:field.id,refInFor:true,attrs:{"field":field},on:{"update":_vm.update_filter}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }